import { ArrayValue, FeaturePropertyKey, Property } from '@vi-iot/client';

export enum COMMISSIONING_STEP {
  START = 'START',
  IDENTIFY_CODE = 'IDENTIFY_CODE',
  TYPE_CODE = 'TYPE_CODE',
  IDENTIFY_CODE_SUCCESS = 'IDENTIFY_CODE_SUCCESS',
  PAIRING = 'PAIRING',
  PAIRING_SUCCESS = 'PAIRING_SUCCESS',
  PAIRING_FAILED = 'PAIRING_FAILED',
  PAIRING_ENDED = 'PAIRING_ENDED',
  // In the future if any new pairing status like Success or Failed can be put here
}

export enum PAIRING_STEPS {
  INITIATING = '1/3',
  LEARNING = '2/3',
  CONNECTING = '3/3',
}

export enum DEVICE_STATUS {
  ONLINE = 'online',
  OFFLINE = 'offline',
}

export enum ZIGBEE_COORDINATOR_STATUS {
  DISABLED = 'Disabled',
  OK = 'OK',
  LEARNING = 'Learning',
  TIMEOUT = 'Timeout',
  LEARNING_FAILED = 'Learning failed',
  INVALID_FORMAT = 'Invalid format',
  ZIGBEE_ERROR = 'Zigbee error',
  ALREADY_PAIRED = 'Already paired',
  INITIATING = 'Initiating',
  CONNECTING = 'Connecting',
  TYPE_MISMATCH = 'TypeMismatch',
  UNKNOWN = 'Unknown', // extra status for ui
}

export enum RemoteDeviceType {
  CS = 'cs',
  CS_REPEATER = 'cs_repeater',
  REPEATER = 'repeater',
  TRV = 'trv',
  FHT = 'fht',
  FHT_CHANNEL = 'fht_channel',
  AIR_QUALITY_SENSOR = 'airQualitySensor',
  VITOTROL_100E = 'vitotrol_100E',
  VITOTROL_300E = 'vitotrol_300E',
  RC_SENSOR = 'rcSensor',
}

export enum AssignableRemoteDeviceType {
  TRV = 'trv',
  CS = 'cs',
  FHT_CHANNEL = 'fht_channel',
  AIR_QUALITY_SENSOR = 'airQualitySensor',
  VITOTROL_300E = 'vitotrol_300E',
  RC_SENSOR = 'rcSensor',
}

export enum UnassignableRemoteDeviceType {
  CS_REPEATER = 'cs_repeater',
  REPEATER = 'repeater',
  FHT = 'fht',
}

export const AddDeviceType = {
  [RemoteDeviceType.CS]: 'cs',
  [RemoteDeviceType.CS_REPEATER]: 'repeater',
  [RemoteDeviceType.REPEATER]: 'repeater',
  [RemoteDeviceType.TRV]: 'trv',
  [RemoteDeviceType.FHT]: 'fht',
  [RemoteDeviceType.AIR_QUALITY_SENSOR]: 'airQualitySensor',
  [RemoteDeviceType.VITOTROL_100E]: 'remoteController',
  [RemoteDeviceType.VITOTROL_300E]: 'remoteController',
};

export interface DevicePairingStatus {
  status: ZIGBEE_COORDINATOR_STATUS;
  step: PAIRING_STEPS;
}

export interface RemoteDeviceCode {
  id: string;
  ic: string;
}

export interface DeviceZigbeeCoordinator {
  device: string;
  value: string;
}

export interface DeviceZigbeeCoordinatorProperties {
  [FeaturePropertyKey.status]: ArrayValue<DeviceZigbeeCoordinator>;
  [FeaturePropertyKey.timeout]: Property;
}

export enum RemoteDeviceModels {
  SmartDeviceETRVGeneric = 'Smart_Device_eTRV_generic',
  SmartCSGeneric = 'Smart_cs_generic',
  SmartZigbeeFhtChannel = 'Smart_zigbee_fht_channel',
  SmartRepeaterGeneric = 'Smart_repeater_generic',
  SmartZigbeeFhtMain = 'Smart_zigbee_fht_main',
}

export enum RemoteDeviceE3Models {
  E3_RadiatorActuator = 'E3_RadiatorActuator',
  E3_Repeater = 'E3_Repeater',
  E3_RoomSensor = 'E3_RoomSensor',
  E3_FloorHeatingCircuitDistributorBox = 'E3_FloorHeatingCircuitDistributorBox',
  E3_FloorHeatingCircuitChannel = 'E3_FloorHeatingCircuitChannel',
}

export enum DeviceAssignmentResult {
  Success = 'Success',
  Error = 'Error',
}

export enum ValidateEuidResult {
  Success = 'Success',
  ErrorAlreadyAdded = 'ErrorAlreadyAdded',
  Error = 'Error',
}
